import { render } from "./CleanLayout.vue?vue&type=template&id=30be3b28"
import script from "./CleanLayout.vue?vue&type=script&lang=js"
export * from "./CleanLayout.vue?vue&type=script&lang=js"
script.render = render

export default script